import type { TeleconsultoriaPresenceStatus } from "./probeTeleconsultoriaPeer";

/** Rótulo e cor do chip de presença (listas de teleconsultores). */
export const PRESENCE_CHIP: Record<
  TeleconsultoriaPresenceStatus,
  { label: string; color: "success" | "default" }
> = {
  online: { label: "Online agora", color: "success" },
  offline: { label: "Offline", color: "default" },
  unknown: { label: "Status desconhecido", color: "default" },
  checking: { label: "Verificando", color: "default" },
};
